
export enum RoutePaths {
    Home = "/",
    SignIn = "/signin",
    External = "/external",
    ResetPassword = "/reset",
    ResetPasswordConfirm = "/reset-token",
    Register = "/register/",
    Lines = "/lines",
    Notes = "/notes",
    NoteItem = "/note/:id",
    NoteEditItem = "/note/:id/edit",
    MediaLines = "/lines",
    MediaLinesItem = "/line/:id",
    MediaLinesEdit = "/line/:id/edit",
    MPs = "/mps",
    MPItem = "/mp/:id",
    MPEdit = "/mp/:id/edit",
    IssueBriefs = "/briefs",
    IssueBriefItem = "/brief/:id",
    IssueBriefEdit = "/brief/:id/edit",
    Achievements = "/achievements",
    AchievementItem = "/achievement/:id",
    AchievementEdit = "/achievement/:id/edit",
    Resources = "/resources",
    ResourceItem = "/resource/:id",
    ResourceEdit = "/resource/:id/edit",
    FAQ = "/faqs",
    FAQItem = "/faq/:id",
    FAQEdit = "/faq/:id/edit",
    OpinionEditorials = "/opeds",
    OpinionEditorialItem = "/oped/:id",
    OpinionEditorialEdit = "/oped/:id/edit",
    People = "/people",
    PersonItem = "/person/:id",
    PersonItemEdit = "/person/:id/edit",
    QuoteItem = "/quote/:id",
    QuoteEdit = "/quote/:id/edit",
    UserCreate = "/user/create",
    UserSearch = "/users/:query?",
    UserEdit = "/user/:id/edit",
    AdvancedSearch = "/advanced_search",
    DataEntry = "/data/new",
    UnPublishedDrafts = "/data/unpublished",
    Tags = "/tags",
    ResourceOnlyTags = "/resource-only-tags",
    ArchivedContent = "/archived",
    SpeakingList = "/speaking-list",
    TweetItem = "/tweets/:id",
    Quotes = "/quotes",
}

export const NoteItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.NoteItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;    
};
export const NoteItemEditRoute = (id: number) => RoutePaths.NoteEditItem.replace(":id", `${id}`);
export const FaqItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.FAQItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;    
};
export const PeopleItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.PersonItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;    
};
export const PersonEditRoute = (id: number) => RoutePaths.PersonItemEdit.replace(":id", `${id}`);
export const FaqEditRoute = (id: number) => RoutePaths.FAQEdit.replace(":id", `${id}`);
export const UserEditRoute = (id: string) => RoutePaths.UserEdit.replace(":id", id);
export const UserSearchRoute = (query: string) => RoutePaths.UserSearch.replace(":query?", encodeURIComponent(query));
export const MPItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.MPItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;    
};
export const MPEditRoute = (id: number) => RoutePaths.MPEdit.replace(":id", `${id}`);
export const MediaLinesItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.MediaLinesItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;    
};
export const MediaLinesEditRoute = (id: number) => RoutePaths.MediaLinesEdit.replace(":id", `${id}`);
export const IssueBriefItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.IssueBriefItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;    
};
export const IssueBriefEditRoute = (id: number) => RoutePaths.IssueBriefEdit.replace(":id", `${id}`);

export const AchievementItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.AchievementItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;    
};
export const AchievementEditRoute = (id: number) => RoutePaths.AchievementEdit.replace(":id", `${id}`);

export const ResourceItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.ResourceItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;    
};
export const ResourceEditRoute = (id: number) => RoutePaths.ResourceEdit.replace(":id", `${id}`); 

export const OpinionEditorialItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.OpinionEditorialItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;
};
export const OpinionEditorialEditRoute = (id: number) => RoutePaths.OpinionEditorialEdit.replace(":id", `${id}`);
export const QuoteItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.QuoteItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;
};

export const QuoteEditRoute = (id: number) => RoutePaths.QuoteEdit.replace(":id", `${id}`);
export const TweetItemRoute = (includeDeleted?: boolean) => (id: number) => {
    const base = RoutePaths.TweetItem.replace(":id", `${id}`);
    if (includeDeleted == true)
        return base + "?includeDeleted=true";
    return base;
};


// WEBPACK FOOTER //
// ./src/route-paths.ts